var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center"},_vm._l((5),function(i){return _c('img',{key:i,staticClass:"w-6",attrs:{"src":_vm.source}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }